<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Employees Listing</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small fab @click="addNewRecord_onClick()" v-on="on" color="primary">
                          <v-icon>
                            add_circle_outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Add new</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-expansion-panel>
                        <v-expansion-panel-content class="accent">
                          <template v-slot:header>
                            <div class="subheading">
                              Filter Panel
                            </div>
                          </template>
                          <v-btn color="green" @click="refreshData()"
                            >Generate Now</v-btn
                          >
                          <FilterEditor
                            :query.sync="new_filter"
                            :rules="get_filterable_columns"
                            class="accent"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear
                            color="blue"
                            indeterminate
                          >
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.id }}</td>
                            <td class="pa-1">{{ props.item.full_name }}</td>
                            <td class="pa-1">
                              {{ props.item.user__username }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.user__email }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.dept_employee__dept__company__name }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.dept_employee__dept__name }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.emp_jg_position__job_grade__desc }}
                            </td>
                            <td class="pa-1">{{ props.item.emp_no }}</td>
                            <td class="pa-1">{{ props.item.ic_no }}</td>
                            <td class="pa-1">{{ props.item.passport_no }}</td>
                            <td class="pa-1">{{ props.item.cost_center__company__name }}</td>
                            <td class="pa-1">{{ props.item.cost_center__name }}</td>
                            <td class="pa-1">
                              {{
                                convert_2_locale_datetime(props.item.created_date)
                              }}
                            </td>
                            <td class="pa-1">{{ props.item.emp_status__value }}</td>
                            <td class="justify-center layout px-0">
                              <v-icon
                                small
                                class="mr-2"
                                color="orange"
                                @click="editRecord_onClick(props.item)"
                              >
                                edit
                              </v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <!-- START dialog -->
          <v-dialog
            v-model="dialog.visible"
            class="ssss"
            persistent
            scrollable
            max-width="600px"
          >
            <v-card>
              <v-card-title class="headline pb-0">
                {{ dialog.title }} [{{ selected.fullname }}] Record
              </v-card-title>
              <v-card-text>
                <v-tabs
                  color="cyan"
                  slider-color="yellow"
                  v-model="tabs.active_tab_id"
                >
                  <v-tab ripple> Profile </v-tab>
                  <v-tab ripple v-show="selected.id">Department</v-tab>
                  <v-tab ripple v-show="selected.id">HOD</v-tab>
                  <v-tab ripple v-show="selected.id">Roles</v-tab>
                  <v-tab-item class="tab-style">
                    <v-form>
                      <v-container grid-list-md class="pa-0">
                        <v-layout row wrap>
                          <v-flex xs12 md5>
                            <v-text-field
                              prepend-icon="account_circle"
                              name="username"
                              v-model="selected.username"
                              v-validate="'required|min:3'"
                              :error-messages="errors.first('username')"
                              label="User Name"
                              type="text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md7>
                            <v-text-field
                              prepend-icon="person"
                              name="fullname"
                              v-model="selected.fullname"
                              v-validate="'required'"
                              :error-messages="errors.first('fullname')"
                              label="Full Name"
                              type="text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              prepend-icon="email"
                              v-model="selected.email"
                              name="email"
                              v-validate="'required|email'"
                              :error-messages="errors.first('email')"
                              label="Email"
                              type="text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              prepend-icon="email"
                              v-model="selected.email_p"
                              name="email_p"
                              :error-messages="errors.first('email')"
                              label="Email (personal)"
                              type="text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              prepend-icon="monetization_on"
                              :items="dialog.company_dept_list"
                              name="cost_center"
                              v-model="selected.cost_center_id"
                              item-text="company_dept"
                              item-value="id"
                              label="Cost Center"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              prepend-icon="work"
                              :items="dialog.jd_list"
                              name="jd"
                              v-model="selected.emp_jg_position_id"
                              item-text="jd"
                              item-value="id"
                              label="Job Grade / Position"
                            ></v-select>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="selected.ic_no"
                              name="ic_no"
                              label="I/C No."
                              type="text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="selected.passport_no"
                              name="passport_no"
                              label="Passport No."
                              type="text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="selected.emp_no"
                              name="emp_no"
                              label="Employee No."
                              type="text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-select
                              :items="emp_status_option"
                              v-model="selected.emp_status_id"
                              item-text="value"
                              item-value="id"
                              label="Status"
                              name="status"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 class="text-xs-right">
                            <v-btn
                              color="green darken-1"
                              flat
                              @click="save_onClick()"
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-tab-item>
                  <v-tab-item class="tab-style">
                    <v-layout row>
                      <v-flex xs12>
                        <v-combobox
                          :items="dialog.company_dept_list"
                          clearable
                          item-text="company_dept"
                          item-value="id"
                          v-model="department_tab.company_dept"
                          label="Member of"
                        ></v-combobox>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs12>
                        <v-list two-line subheader dense>
                          <v-list-tile
                            v-for="dept_emp_item in department_tab.saved_company_dept"
                            :key="dept_emp_item.id"
                            avatar
                          >
                            <v-list-tile-avatar>
                              <v-icon>category</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                dept_emp_item.dept__company__name
                              }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{
                                dept_emp_item.dept__name
                              }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-btn
                                icon
                                ripple
                                @click="delete_dept(dept_emp_item)"
                              >
                                <v-icon color="grey lighten-1"
                                  >delete_forever</v-icon
                                >
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item class="tab-style">
                    <v-layout row>
                      <v-flex xs12>
                        <v-combobox
                          :items="dialog.company_dept_list"
                          clearable
                          item-text="company_dept"
                          item-value="id"
                          v-model="hod_tab.hod_company_dept"
                          label="Member of"
                        ></v-combobox>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs12>
                        <v-list two-line subheader dense>
                          <v-list-tile
                            v-for="dept_emp_item in hod_tab.saved_hod"
                            :key="dept_emp_item.id"
                            avatar
                          >
                            <v-list-tile-avatar>
                              <v-icon>how_to_reg</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                dept_emp_item.dept__company__name
                              }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{
                                dept_emp_item.dept__name
                              }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-btn icon ripple @click="delete_hod(dept_emp_item)">
                                <v-icon color="grey lighten-1"
                                  >delete_forever</v-icon
                                >
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item class="tab-style">
                    <v-layout row>
                      <v-flex xs12>
                        <v-combobox
                          :items="role_options"
                          clearable
                          item-text="name"
                          item-value="id"
                          v-model="roles_tab.role"
                          label="Member of"
                        ></v-combobox>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs12>
                        <v-list two-line subheader dense>
                          <v-list-tile
                            v-for="role_item in roles_tab.saved_roles"
                            :key="role_item.id"
                            avatar
                          >
                            <v-list-tile-avatar>
                              <v-icon>group</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                role_item.group__name
                              }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{
                                role_item.group__name
                              }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-btn icon ripple @click="delete_role(role_item)">
                                <v-icon color="red">delete_forever</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
              <v-card-actions>
                <v-container>
                  <v-layout row wrap>
                    <v-flex class="text-xs-right">
                      <v-btn
                        flat
                        color="orange"
                        @click="
                          dialog.visible = false;
                          tabs.active_tab_id = 0;
                        "
                      >
                        Close
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END dialog -->
        </v-container>
      </v-slide-y-transition>
    </v-flex>
  </v-layout>
  
</template>

<script>
import common from "../../functions/general";
import qb from "../../functions/query.builder";
import FilterEditor from "../../components/FilterEditor";

export default {
  name: "EmployeesListingPage",
  components: {
    FilterEditor: FilterEditor
  },
  data() {
    return {
      new_filter: {
        condition: "and",
        rules: []
      },
      tabs: {
        active_tab_id: 0
      },
      emp_status_option: [],
      role_options: [],
      dialog: {
        visible: false,
        title: "",
        company_dept_list: [],
        jd_list: []
      },
      selected: {
        id: "",
        username: "",
        fullname: "",
        email: "",
        email_p: "",
        emp_no: "",
        ic_no: "",
        passport_no: "",
        emp_status_id: "",
        cost_center_id: "",
        emp_jg_position_id: "",
        user_id: ""
      },
      department_tab: {
        company_dept: "",
        saved_company_dept: []
      },
      hod_tab: {
        hod_company_dept: "",
        saved_hod: []
      },
      roles_tab: {
        role: "",
        saved_roles: []
      },
      table_setting: {
        loading: false,
        rows_per_page_items: [20, 40, 60, 80, 100, 200, 500, 1000, 2000, 5000],
        headers: [
          {
            text: "ID#",
            value: "id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Full Name",
            class: "pa-1",
            value: "full_name",
            filterable: true,
            data_type: String
          },
          {
            text: "User Name",
            align: "left",
            class: "pa-1",
            value: "user__username",
            filterable: true,
            data_type: String
          },
          {
            text: "Email",
            class: "pa-1",
            value: "user__email",
            filterable: true,
            data_type: String
          },
          {
            text: "Company",
            align: "left",
            class: "pa-1",
            value: "dept_employee__dept__company__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Dept Name",
            align: "left",
            class: "pa-1",
            value: "dept_employee__dept__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Job Grade",
            align: "left",
            class: "pa-1",
            value: "emp_jg_position__job_grade__desc",
            filterable: true,
            data_type: String
          },
          {
            text: "Emp #",
            align: "left",
            class: "pa-1",
            value: "emp_no",
            filterable: true,
            data_type: String
          },
          {
            text: "IC #",
            align: "left",
            class: "pa-1",
            value: "ic_no",
            filterable: true,
            data_type: String
          },
          {
            text: "Passport #",
            align: "left",
            class: "pa-1",
            value: "passport_no",
            filterable: true,
            data_type: String
          },
          {
            text: "Cost Center",
            align: "left",
            class: "pa-1",
            value: "cost_center__company__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Cost Center Dept",
            align: "left",
            class: "pa-1",
            value: "cost_center__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Created DateTime",
            align: "left",
            class: "pa-1",
            value: "created_date",
            filterable: true,
            data_type: Number
          },
          {
            text: "Status",
            align: "left",
            class: "pa-1",
            value: "emp_status__value",
            filterable: true,
            data_type: String
          },
          {
            text: "",
            value: "a_actions",
            class: "pa-1",
            filterable: false,
            data_type: Number
          }
        ],
        records: [],
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 20,
          sortBy: "full_name",
          totalItems: 0
        }
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    },
    "hod_tab.hod_company_dept"(val) {
      if (val != "") {
        var temp = this.hod_tab.saved_hod.find(item => {
          return item.id == val.id;
        });

        if (!temp) {
          // add dept employee here
          var option = {
            id: "",
            emp_id: this.selected.id,
            dept_id: val.id
          };

          this.update_hod(option);
        }
        this.hod_tab.hod_company_dept = "";
      }
    },
    "department_tab.company_dept"(val) {
      if (val != "") {
        var temp = this.department_tab.saved_company_dept.find(item => {
          return item.id == val.id;
        });

        if (!temp) {
          // add dept employee here
          var option = {
            id: "",
            emp_id: this.selected.id,
            dept_id: val.id
          };

          this.update_dept_employee(option);
        }
        this.department_tab.company_dept = "";
      }
    },
    "roles_tab.role"(val) {
      if (val) {
        var temp = this.roles_tab.saved_roles.find(item => {
          return item.group_id == val.id;
        });

        if (!temp) {
          // add dept employee here
          var option = {
            id: "",
            user_id: this.selected.user_id,
            group_id: val.id
          };

          this.add_user_groups(option);
        }
        this.department_tab.company_dept = "";
      }
    },
    "selected.id"(val) {
      if (val != "") {
        this.refresh_dept_employee(val);
        this.refresh_hod(val);
        this.refresh_user_groups(this.selected.user_id);
      }
    }
  },
  async mounted() {
    this.emp_status_option = await common.App.getGeneralOptions(
      "Employee",
      "emp_status",
      ["id", "value"]
    );

    let cls_qb = new qb.QueryBuilder();

    cls_qb.Method = "all";

    cls_qb.Select = [
      "id",
      "name",
      "desc",
      "g_status_id",
      "g_status__value",
      "company_id",
      "company__name",
      "parent_dept_id",
      "parent_dept__company__name",
      "parent_dept__name"
    ];

    cls_qb.Order = ["company__name", "name"];
    let result = await common.wBackEndComm.PostData(
      "department/department_listing/",
      cls_qb
    );

    if (result.data.Status == 1) {
      for (let i = 0, m = result.data.Body.records.length; i < m; i++) {
        const element = result.data.Body.records[i];

        element["company_dept"] =
          element["company__name"] + " - " + element["name"];
      }

      this.dialog.company_dept_list = result.data.Body.records;
    } else {
      common.wMsgBox.Error(result.data.Description);
    }

    // Call for JD list //
    let cls_qb_jd = new qb.QueryBuilder();
    cls_qb_jd.Method = "all";

    cls_qb_jd.Table = "emps_jg_position";
    cls_qb_jd.Select = [
      "id",
      "job_grade__desc",
      "position__desc",
      "g_status_id",
      "g_status__value"
    ];

    cls_qb_jd.Order = ["job_grade__desc"];
    let result_jd = await common.wBackEndComm.PostData("process_qb/", cls_qb_jd);

    if (result_jd.data.Status == 1) {
      for (let i = 0, m = result_jd.data.Body.records.length; i < m; i++) {
        const element_jd = result_jd.data.Body.records[i];

        element_jd["jd"] =
          element_jd["job_grade__desc"] + " (" + element_jd["position__desc"] + ")";
      }

      this.dialog.jd_list = result_jd.data.Body.records;
    } else {
      common.wMsgBox.Error(result_jd.data.Description);
    }


    this.load_roles();
    //this.refreshData();
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },
    async load_roles() {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Table = "auth_group";
      cls_qb.Method = "all";
      cls_qb.Select = ["id", "name"];
      cls_qb.Order = ["name"];

      let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

      if (result.data.Status == 1) {
        this.role_options = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async refresh_user_groups(user_id) {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = ["id", "group__name", "group_id"];

      var rule = new qb.Rule();

      rule
        .field("user_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(user_id);

      cls_qb.addRule(rule);

      let result = await common.wBackEndComm.PostData(
        "user_groups/listing/",
        cls_qb
      );

      if (result.data.Status == 1) {
        this.roles_tab.saved_roles = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async refresh_hod(emp_id) {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = ["id", "dept__id", "dept__name", "dept__company__name"];

      var rule = new qb.Rule();

      rule
        .field("emp_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(emp_id);

      cls_qb.addRule(rule);

      let result = await common.wBackEndComm.PostData("hod/listing/", cls_qb);

      if (result.data.Status == 1) {
        this.hod_tab.saved_hod = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async refresh_dept_employee(emp_id) {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = ["id", "dept__id", "dept__name", "dept__company__name"];

      var rule = new qb.Rule();

      rule
        .field("emp_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(emp_id);

      cls_qb.addRule(rule);

      let result = await common.wBackEndComm.PostData(
        "dept_employee/listing/",
        cls_qb
      );

      if (result.data.Status == 1) {
        this.department_tab.saved_company_dept = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async refreshData() {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = [
        "id",
        "full_name",
        "emp_no",
        "ic_no",
        "emp_status_id",
        "emp_status__value",
        "user__username",
        "passport_no",
        "user__email",
        "cost_center_id",
        "cost_center__company__name",
        "cost_center__name",
        "emp_jg_position_id",
        "emp_jg_position__job_grade__desc",
        "created_date",
        "dept_employee__dept__company__name",
        "dept_employee__dept__name",
        "user_id",
        "email_p"
      ];

      cls_qb.Where = this.new_filter;

      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData(
        "employees/employees_listing/",
        cls_qb
      );

      if (result.data.Status == 1) {
        var start = 1;

        for(var i=0,m=result.data.Body.records.length;i<m;i++){
          var el = result.data.Body.records[i];

          el["rec_id"] = el["id"]
          el["id"] = start;
          start++;
        }
        
        this.table_setting.records = result.data.Body.records;

        this.table_setting.pagination.totalItems =
          result.data.Body.total_records_after_filtered;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    editRecord_onClick(item) {
      this.dialog.visible = true;
      this.dialog.title = "Modifying ";
      
      this.$validator.reset();

      this.selected = {
        id: item["rec_id"],
        username: item["user__username"],
        fullname: item["full_name"],
        email: item["user__email"],
        emp_no: item["emp_no"],
        ic_no: item["ic_no"],
        user_id: item["user_id"],
        cost_center_id: item["cost_center_id"],
        emp_jg_position_id: item["emp_jg_position_id"],
        passport_no: item["passport_no"],
        emp_status_id: item["emp_status_id"],
        email_p: item["email_p"]
      };
    },
    addNewRecord_onClick() {
      this.dialog.visible = true;
      this.dialog.title = "Create";

      this.$validator.reset();

      this.selected = {
        id: "",
        username: "",
        fullname: "",
        email: "",
        emp_no: "",
        ic_no: "",
        user_id: "",
        passport_no: "",
        cost_center_id:"",
        emp_jg_position_id:"",
        emp_status_id: this.emp_status_option[0].id,
        email_p: ""
      };
    },
    save_onClick() {
      let self = this;

      this.$validator.validateAll().then(async result => {
        if (result) {
          let result = await common.wBackEndComm.PostData(
            "employees/crud_employees/",
            self.selected
          );

          if (result.data.Status == 1) {
            self.dialog.visible = false;
            self.refreshData();
            common.wMsgBox.Success(result.data.Description);
          } else {
            common.wMsgBox.Error(result.data.Description);
          }
        }
      });
    },
    async update_dept_employee(option) {
      var self = this;
      let result = await common.wBackEndComm.PostData(
        "dept_employee/crud/",
        option
      );

      if (result.data.Status == 1) {
        self.refresh_dept_employee(self.selected.id);
        common.wMsgBox.Success(result.data.Description);
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async add_user_groups(option) {
      var self = this;
      let result = await common.wBackEndComm.PostData(
        "user_groups/crud/",
        option
      );

      if (result.data.Status == 1) {
        self.refresh_user_groups(self.selected.user_id);
        common.wMsgBox.Success(result.data.Description);
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async update_hod(option) {
      var self = this;
      let result = await common.wBackEndComm.PostData("hod/crud/", option);

      if (result.data.Status == 1) {
        self.refresh_hod(self.selected.id);
        common.wMsgBox.Success(result.data.Description);
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async delete_hod(dept_emp_rec) {
      var option = dept_emp_rec;

      await this.update_hod(option);
    },
    async delete_dept(dept_emp_rec) {
      var option = dept_emp_rec;

      await this.update_dept_employee(option);
    },
    async delete_role(role_rec) {
      var self = this;
      var option = {
        group_id: role_rec.group_id,
        user_id: this.selected.user_id
      };
      //role_rec;

      let result = await common.wBackEndComm.DeleteData(
        "user_groups/crud/",
        option
      );

      if (result.data.Status == 1) {
        self.refresh_user_groups(self.selected.user_id);
        common.wMsgBox.Success(result.data.Description);
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    }
  }
};
</script>

<style scoped>
.tab-style {
  height: 350px;
  margin-top: 5px;
}
</style>
